import "./Aliases.scss";
import {
  IonAvatar,
  IonContent,
  IonFab,
  IonFabButton,
  IonFabList,
  IonIcon,
  IonItem,
  IonItemOption,
  IonItemOptions,
  IonItemSliding,
  IonLabel,
  IonList,
  IonLoading,
  IonPage,
  useIonViewWillEnter,
} from "@ionic/react";
import {
  add,
  // appsOutline,
  // callOutline,
  // fingerPrintOutline,
} from "ionicons/icons";
import React, { useState } from "react";
import { useTracked } from "../../state";
import { Plugins } from "@capacitor/core";
import {
  BarcodeScanner,
  BarcodeScannerOptions,
} from "@ionic-native/barcode-scanner";
import { getAliases, updateAlias } from "../../api/user";
import pencilIcon from "../../assets/svg/pencil.svg";
import qrCodeIcon from "../../assets/svg/qrcode.svg";
import aliasesIcon from "../../assets/svg/aliases.svg";
import copyIcon from "../../assets/svg/copy.svg";
import deleteIcon from "../../assets/svg/delete.svg";
import burnerIcon from "../../assets/svg/burner.svg";
// import checkCircleIcon from "../../assets/svg/check-circle.svg";
// import { useLongPress } from "../../utils/hooks";
import { ShowToastSuccessMessage } from "../../utils/helpers/ToastMessage";
import { useHistory } from "react-router-dom";
import PrivateHeader from "../../components/PrivateHeader";

const { Clipboard } = Plugins;

interface Props {
  identity: string;
}

const Aliases: React.FC<Props> = React.memo(({ identity }) => {
  const history = useHistory();
  const [aliases, setAliases] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useIonViewWillEnter(() => {
    if (identity) {
      fetchAliases(identity);
    }
  }, [identity]);

  const fetchAliases = async (identity: string) => {
    try {
      setLoading(true);

      const response: any = await getAliases(identity);

      if (response?.status === 200) {
        const { data = [] } = response;
        setAliases(data);
      }

      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const onDelete = async (alias: any) => {
    try {
      setLoading(true);

      const response: any = await updateAlias(alias.id, {
        enabled: false,
        alias: alias.alias,
      });

      if (response?.status === 200) {
        ShowToastSuccessMessage("Alias successfully deleted");
        setLoading(false);
        fetchAliases(identity);
      } else {
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  const scanBarcode = () => {
    const options: BarcodeScannerOptions = {
      disableAnimations: true,
      preferFrontCamera: false,
      showFlipCameraButton: false,
      showTorchButton: true,
      torchOn: false,
      prompt: "Place qr code inside the scan area",
      resultDisplayDuration: 500,
      formats: "QR_CODE,PDF_417",
      orientation: "portrait",
    };

    BarcodeScanner.scan(options)
      .then((data: any) => {
        console.log("qrcode data", data);
      })
      .catch((e: any) => console.log(e));
  };

  const handleCopyClipboard = async (value: string) => {
    try {
      await Clipboard.write({ string: value });
      ShowToastSuccessMessage("Alias copied to clipboard");
    } catch (e) {
      console.log(e);
    }
  };

  // const onLongPress = (e: any) => {
  //   console.log(
  //     "calls callback after long pressing 300ms",
  //     e.target.getAttribute("alias-value")
  //   );
  //   const alias = e.target.getAttribute("alias-value");
  //   handleCopyClipboard(alias);
  // };

  // const onClickAlias = (e: any) => {
  //   console.log(
  //     "calls callback after click",
  //     e.target.getAttribute("alias-value")
  //   );
  // };

  // const longPressEvent = useLongPress({
  //   onLongPress,
  //   onClick: onClickAlias,
  //   ms: 1000,
  // });

  return (
    <IonPage className="aliases-page">
      <PrivateHeader title="Aliases" />

      <IonContent>
        <div className="aliases-container">
          <IonList>
            {aliases &&
              aliases.length > 0 &&
              aliases.map((aliasObj: any, index: number) => {
                const {
                  // authMode,
                  alias,
                  appId,
                  enabled,
                  burner,
                } = aliasObj;
                // const mode = authMode;

                return (
                  <IonItemSliding key={index} id={alias} hidden={!enabled}>
                    <IonItem
                      key={index}
                      id={alias}
                      lines="full"
                      onClick={() => {
                        history.push(`/add-alias/${aliasObj.id}`);
                      }}
                    >
                      {/* {mode === 1 && (
                        <IonIcon
                          icon={appsOutline}
                          slot="start"
                          color="medium"
                        />
                      )}
                      {mode === 9 && (
                        <IonIcon
                          icon={callOutline}
                          slot="start"
                          color="medium"
                        />
                      )}
                      {mode === 0 && (
                        <IonIcon
                          icon={fingerPrintOutline}
                          slot="start"
                          color="danger"
                        />
                      )}
                      {(mode === 5 || mode === "5") && ( */}
                      <IonAvatar slot="start" className="aliases-thumbnail">
                        <img src={aliasesIcon} alt="" />
                        {/* <IonIcon
                          icon={aliasesIcon}
                          slot="start"
                          color="medium"
                        /> */}
                      </IonAvatar>
                      {/* )} */}

                      <IonLabel className="sc-IonLabel-ios-h sc-IonLabel-ios-s ios hydrated">
                        <h3 alias-value={alias}>
                          {appId === 1 && "Verifier"}
                          {appId === 2 && "Messenger"}
                          {appId === 3 && "Exchange"}
                          {appId === 4 && "Sign"}
                          {appId === 0 && "All Apps"}
                        </h3>
                        <p>{alias}</p>
                      </IonLabel>

                      {/* <IonButton
                        fill="clear"
                        onClick={() => {
                          handleCopyClipboard(alias);
                        }}
                      >
                        <IonIcon
                          icon={clipboardOutline}
                          slot="end"
                          color="medium"
                        />
                      </IonButton> */}
                      {burner && <IonIcon icon={burnerIcon} slot="end" />}
                    </IonItem>

                    <IonItemOptions side="end">
                      <IonItemOption
                        className="copy-alias"
                        onClick={() => handleCopyClipboard(alias)}
                      >
                        <div className="sliding-btn-container">
                          <IonIcon icon={copyIcon} />
                          <span>Copy</span>
                        </div>
                      </IonItemOption>
                      <IonItemOption
                        className="delete-alias"
                        onClick={() => onDelete(aliasObj)}
                      >
                        <div className="sliding-btn-container">
                          <IonIcon icon={deleteIcon} />
                          <span>Delete</span>
                        </div>
                      </IonItemOption>
                    </IonItemOptions>
                  </IonItemSliding>
                );
              })}
          </IonList>
        </div>

        <IonFab
          vertical="bottom"
          horizontal="center"
          slot="fixed"
          className="custom-fab-btn"
        >
          <IonFabButton mode="ios">
            <IonIcon icon={add} />
          </IonFabButton>
          <IonFabList side="start" className="scan-add-btn">
            <IonFabButton mode="ios" onClick={scanBarcode}>
              <IonIcon icon={qrCodeIcon} />
            </IonFabButton>
          </IonFabList>
          <IonFabList side="end" className="manual-add-btn">
            <IonFabButton mode="ios" routerLink="/add-alias">
              <IonIcon icon={pencilIcon} />
            </IonFabButton>
          </IonFabList>
        </IonFab>

        <IonLoading
          isOpen={loading}
          onDidDismiss={() => setLoading(false)}
          message={"Please wait..."}
        />
      </IonContent>
    </IonPage>
  );
});

const MemoizedAliases = () => {
  const [state] = useTracked();
  const { identity } = state;
  return <Aliases identity={identity} />;
};

export default MemoizedAliases;
